import React from 'react'
import UndoRedoComponent from '../components/common/UndoRedoComponent';
import { connect } from 'react-redux'
import Version from '../Version';

const mapStateToProps = (state) => {
  return {
    ...state, 
    canUndo: Version.canUndo(),
    canRedo: Version.canRedo()
  }
}

const UndoRedoContainer = connect(
  mapStateToProps
)(UndoRedoComponent)

export default UndoRedoContainer;